module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAT4BAMAAAAr6bV4AAAAJ1BMVEX+///U8//5/f/c9f/W8//w+//Z9P/0/P/j9//p+f/g9v/t+f/m+P+qRjRoAAAAjUlEQVRIx+3SYQ2AIBQEYCMYwQhGIIIRiGAEIxiBCEYwmt4YnA7eZDLYnLxvx4k4fzi7RWDsKhp9j1iT6VvrZOrSioJ9b1fL7a/9Karsu6LfRTk8YSfSYTOAfsv9PwUYKQ8WHzBMph2J4fntiVVO1OrtTIaNHeaFCRHuTYCubD7xGtD1DFJ+rk2bNg9zAABdFeA9i5ZNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./images/baseintrov2/v2-bg1-left.png
// module id = 556
// module chunks = 0